<template>
  <div class="m-t-20">
    <table class="cross-table" cellpadding=2 cellspacing=0 v-if="display.direction==10">
      <thead>
        <tr>
          <th v-for="item in table">{{item.name}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td v-for="item in table">{{item.value}}</td>
        </tr>
      </tbody>
    </table>
    <el-table
      v-else
      :data="table"
      style="width:100%">
      <el-table-column
        prop="name"
        label="名称">
      </el-table-column>
      <el-table-column
        prop="value"
        label="数值">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: ['table', 'display'],
  data() {
    return {}
  },
  watch: {
    'table'() {},
    'display'() {
      // console.log('display', this.display)
    }
  }
}
</script>
<style scoped>
  .cross-table{
    width:100%;
    border: 1px solid #cdcdcd;
  }
  .cross-table thead tr{
    height:50px;
    line-height:50px;
    font-size: 14px;
    background-color: #f7f9fd;
    border-bottom: 1px solid;
  }
  .cross-table tbody tr{
    background-color: #fff;
    height:50px;
    line-height: 50px;
    text-align: center;
    border-bottom: 1px solid #cecece;
  }
  .cross-table tbody tr:hover{
    background-color: ;
  }
</style>


// WEBPACK FOOTER //
// dimensionalTable.vue?d68bcd7a